var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYtAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16651 17C2.46793 13.7033 2.46793 10.2967 3.16651 7C3.2583 6.66521 3.43565 6.36007 3.68112 6.11461C3.92659 5.86914 4.23172 5.69179 4.56651 5.6C9.92996 4.71146 15.4031 4.71146 20.7665 5.6C21.1013 5.69179 21.4064 5.86914 21.6519 6.11461C21.8974 6.36007 22.0747 6.66521 22.1665 7C22.8651 10.2967 22.8651 13.7033 22.1665 17C22.0747 17.3348 21.8974 17.6399 21.6519 17.8854C21.4064 18.1309 21.1013 18.3082 20.7665 18.4C15.4031 19.2887 9.92994 19.2887 4.56651 18.4C4.23172 18.3082 3.92659 18.1309 3.68112 17.8854C3.43565 17.6399 3.2583 17.3348 3.16651 17Z",
    stroke: "#3C3C43",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 15L15.667 12L10.667 9V15Z",
    stroke: "#3C3C43",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtAdmin);
export default __webpack_public_path__ + "static/media/yt-admin.77fd4f2df3acc23e839c10805c206d32.svg";
export { ForwardRef as ReactComponent };